import React from 'react';
import TopicCard from './TopicCard';
import { Category } from '../types';

interface TopicGridProps {
  category: Category;
}

export default function TopicGrid({ category }: TopicGridProps) {
  // Mock topics for demonstration - in a real app, this would come from an API
  const mockTopics = Array(6).fill(null).map((_, index) => ({
    id: `${category.id}-${index}`,
    title: `Latest ${category.name} Insights ${index + 1}`,
    description: `Exploring the latest developments and trends in ${category.name}.`,
    category: category,
    author: {
      id: '1',
      name: 'Sarah Johnson',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
      role: 'user'
    },
    createdAt: new Date(Date.now() - Math.random() * 10000000000),
    type: index % 2 === 0 ? 'article' : 'video',
    content: '',
    thumbnailUrl: `https://images.unsplash.com/photo-${1550000000000 + index}?w=1200`
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {mockTopics.map(topic => (
        <TopicCard key={topic.id} topic={topic} />
      ))}
    </div>
  );
}